import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SELECT_MEDIA_VEHICLES, MEDIA_VEHICLE_OPTIONS } from './MMEConstants';
import GenericCheckboxList from '../common/GenericCheckboxList';
import DynamicTabs from '../common/DynamicTabs';

class MMEMediaVehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  updateList = e => {
    const { selectedMediaVehicleIndex, mediaList } = this.props;
    this.props.onChangeProperty(selectedMediaVehicleIndex, mediaList, e, 'mediaList');
  };

  renderVehicleProperties = tabTitle => {
    const { selectedMediaVehicleIndex, mediaList, vehicleCodeCount } = this.props;
    return (<div className="checkboxList">
      <div className="mediaSearchBox" data-test="MediaVehicleTabsPanel">
        <p className="mediaVehicleCount">{vehicleCodeCount} Media Vehicles</p>
      </div>
      {mediaList && mediaList[selectedMediaVehicleIndex].length > 0 &&
        <GenericCheckboxList
          data-test="MediaVehiclePropertyList"
          options={mediaList[selectedMediaVehicleIndex]}
          allCheckboxTitle={tabTitle}
          updateList={this.updateList}
          unique="c"
        />
      }
    </div>);
  };

  render() {
    const { selectedMediaVehicleIndex, mediaList } = this.props;
    let updatedTabs = [
      {
        title: MEDIA_VEHICLE_OPTIONS[0].label,
        content: (this.renderVehicleProperties(MEDIA_VEHICLE_OPTIONS[0].label)),
      },
      {
        title: MEDIA_VEHICLE_OPTIONS[1].label,
        content: (this.renderVehicleProperties(MEDIA_VEHICLE_OPTIONS[1].label)),
      },
      {
        title: MEDIA_VEHICLE_OPTIONS[2].label,
        content: (this.renderVehicleProperties(MEDIA_VEHICLE_OPTIONS[2].label)),
      },
      {
        title: MEDIA_VEHICLE_OPTIONS[3].label,
        content: (this.renderVehicleProperties(MEDIA_VEHICLE_OPTIONS[3].label)),
      },
    ];
    if (mediaList && mediaList[4].length) {
      updatedTabs = [...updatedTabs, {
        title: MEDIA_VEHICLE_OPTIONS[4].label,
        content: (this.renderVehicleProperties(MEDIA_VEHICLE_OPTIONS[4].label)),
      }]
    }
    return (
      <div data-test="MediaVehiclesComp">
        <span className="heading-label">{SELECT_MEDIA_VEHICLES}</span>
        <DynamicTabs
          data-list="DynamicTabsComp"
          styles={{ width: '20%', textAlign: 'center' }}
          selectedIndex={selectedMediaVehicleIndex}
          tabs={updatedTabs}
          handleSelect={this.props.handleSelect}
        />
      </div>
    );
  }
}

MMEMediaVehicles.propTypes = {
  mediaList: PropTypes.shape({}),
  handleSelect: PropTypes.func,
  selectedMediaVehicleIndex: PropTypes.number,
  vehicleCodeCount: PropTypes.number,
  onChangeProperty: PropTypes.func,
};

export default MMEMediaVehicles;
